import AliOss from 'ali-oss';

let options = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAI8UIymyrGyBJo',
  accessKeySecret: 'TgUaBCFsjkoJqHMDk3iqcVebdW4y5z',
  bucket: 'big-image-uplaod'
};

export default (option, file) => {
  if (option.bucket) {
    options.bucket = option.bucket;
  }
  let storeAs = '';
  let prefix = option.prefix ? option.prefix : 'big-img-zx';
  let fileType = file.name.split('.')[1];
  if (option.name) {
    storeAs = `${option.name}`;
  } else {
    storeAs = `${prefix}-${new Date().getTime()}`;
  }
  let client = new AliOss(options);
  // let fileName = file.name
  return client.put(storeAs, file).then(res => res);
};
